<template>
  <div class="c-App" data-component="App">
    <Tabs :tabs="demoTabs" :selectedTabId="'Demo 1'"/>
    <a class="readme" title="Open Readme" href="https://github.com/AlttiRi/vue-file-input" target="_blank"><i>i</i></a>
  </div>
</template>

<script setup lang="ts">
import Demo1 from "./Demo1.vue";
import Demo2 from "./Demo2.vue";
import Demo3 from "./Demo3.vue";

import Tabs, {type TabItem} from "./Tabs.vue";
const demoTabs: TabItem[] = [
  { id: "Demo 1", component: Demo1 },
  { id: "Demo 2", component: Demo2 },
  { id: "Demo 3", component: Demo3 },
];
</script>

<style scoped>
.c-App {
  padding: 20px;
  border: 1px solid #ccc;

  width: 100%;
  max-width: 100vw;
  min-width: 320px;

  min-height: 480px;
  align-self: start;
  margin-top: 20px;
}

@media (min-width: 720px) {
  .c-App {
    min-width: 480px;
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
  }
}

.readme {
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 2px 8px;
  margin: 1px;
  color: darkgray;
  text-decoration: none;
}
</style>
